module.exports = __webpack_public_path__ + "media/icons/check-67c6980d.svg";